import DocumentIcon from '@heroicons/react/outline/DocumentIcon'
import { Link } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'

export const NotFound = ({ title = '', description = '', icon = false }) => {
  return (
    <Card>
      <Card.Content>
        <div className="py-12">
          <EmptyState
            icon={icon || <DocumentIcon />}
            title={
              title || (
                <T
                  defaultMessage="Page not found!"
                  id="Generics.PageNotFound"
                />
              )
            }
            description={
              description || (
                <T
                  defaultMessage="We were not able to find the page you’re looking for."
                  id="Generics.PageNotFound.Explained"
                />
              )
            }
          >
            <Button variant="outline" as={Link} to="/">
              <T defaultMessage="Home" id="Generics.Home" />
            </Button>
          </EmptyState>
        </div>
      </Card.Content>
    </Card>
  )
}
